module.exports = __webpack_public_path__ + "static/assets/e0a851c8a6ebbd4fe4f4db21e1ecb1d0.svg";